import React, { useState } from 'react';
import './Login.css';

interface SimpleLoginProps {
  onLoginSuccess: (username: string, password: string) => Promise<boolean>;
}

const SimpleLogin: React.FC<SimpleLoginProps> = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    
    try {
      const success = await onLoginSuccess(username, password);
      if (!success) {
        alert('Credenciais inválidas. Verifique seu usuário e senha.');
      }
    } catch (error) {
      alert('Erro no login. Tente novamente.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card-simple">
        {/* Logo Prime Wind */}
        <div className="logo-container">
          <img 
            src="/logo.png" 
            alt="Prime Wind Logo" 
            className="logo-image"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
        </div>

        {/* Título do Sistema */}
        <div className="system-header">
          <h1 className="system-title">SCADA</h1>
          <p className="system-subtitle">DEMO VERSION</p>
        </div>



        {/* Formulário de Login */}
        <div className="login-form">
          <div className="form-group">
            <label className="form-label">Usuário</label>
            <input
              type="text"
              placeholder="Digite seu usuário"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="simple-input"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Senha</label>
            <input
              type="password"
              placeholder="Digite sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="simple-input"
            />
          </div>

          <button
            className="simple-button"
            disabled={loading}
            onClick={handleLogin}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SimpleLogin;